import { Control } from 'react-hook-form';
import { usePrevious } from 'react-use';

import { BindingCreator } from '@dreryk/react-common';

import { DateFilter, DateFilterType } from '../../../AppointmentsFilterChips/DateChipFilter.types';
import { FilterFormBean } from '../../AppointmentsFilterPanel';
import { useGetDateFilterTypeChoice } from '../ButtonGroupField/ButtonGroupField.hooks';
import { DatePickerField } from '../DatePickerField/DatePickerField';
import { DateRangeField } from '../DateRangeField/DateRangeField';

type DateFieldProps = {
   readonly register: BindingCreator<FilterFormBean>;
   readonly control: Control<FilterFormBean>;
   readonly currentFilter: DateFilter | null;
};

export const DateField = (props: DateFieldProps): JSX.Element | null => {
   const filterTypeChoice = useGetDateFilterTypeChoice(props.control);
   const previousFilterType = usePrevious(filterTypeChoice);

   if (filterTypeChoice === DateFilterType.DAY) {
      return (
         <DatePickerField
            register={props.register}
            control={props.control}
            dateFilterValue={props.currentFilter?.range}
         />
      );
   }

   if (filterTypeChoice === DateFilterType.RANGE) {
      return (
         <DateRangeField
            register={props.register}
            control={props.control}
            dateFilterValue={props.currentFilter?.range}
            previousFilterType={previousFilterType}
         />
      );
   }
   return null;
};
